import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

const ThemeModeContext = createContext({ mode: 'light', toggleMode: () => {} });

export const useThemeMode = () => useContext(ThemeModeContext);

const STORAGE_KEY = 'themeMode';

export const ThemeModeProvider = ({ children }) => {
  // Light is the default; a previous choice is remembered per device
  const [mode, setMode] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === 'dark' || saved === 'light' ? saved : 'light';
    } catch (error) {
      return 'light';
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (error) { /* private mode */ }
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  const value = useMemo(() => ({
    mode,
    toggleMode: () => setMode(m => (m === 'light' ? 'dark' : 'light')),
  }), [mode]);

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export default ThemeModeContext;
